<div class="tracker-header clearfix">
    <div class="pull-right">
      <!-- <div class="table-search relative">
        <input type="text" #searchField class="table-search-field" [(ngModel)]="searchText"
          (keyup.enter)="searchValue(searchField.value)">
        <span *ngIf="searchText.length > 0" class="table-clear-icon ml-10" (click)="clearSearch(searchField)">
          <svg style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" xml:space="preserve">
            <path
              d="M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z" />
          </svg>
        </span>
        <span class="table-search-icon ml-10" (click)="searchValue(searchField.value)">
          <svg enable-background="new 0 0 32 32" id="Glyph" version="1.1" viewBox="0 0 32 32" xml:space="preserve">
            <path
              d="M27.414,24.586l-5.077-5.077C23.386,17.928,24,16.035,24,14c0-5.514-4.486-10-10-10S4,8.486,4,14  s4.486,10,10,10c2.035,0,3.928-0.614,5.509-1.663l5.077,5.077c0.78,0.781,2.048,0.781,2.828,0  C28.195,26.633,28.195,25.367,27.414,24.586z M7,14c0-3.86,3.14-7,7-7s7,3.14,7,7s-3.14,7-7,7S7,17.86,7,14z"
              id="XMLID_223_" />
          </svg>
        </span>
      </div> -->
      <!-- <span (click)="addDataClick()" class="table-add-icon ml-10"> -->
        <!-- <svg id="Layer_1" style="enable-background:new 0 0 32 32;" version="1.1" viewBox="0 0 32 32" xml:space="preserve">
          <path
            d="M28,14H18V4c0-1.104-0.896-2-2-2s-2,0.896-2,2v10H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h10v10c0,1.104,0.896,2,2,2  s2-0.896,2-2V18h10c1.104,0,2-0.896,2-2S29.104,14,28,14z" />
        </svg> -->
        <button class="btn btn-primary ml-10" (click)="addDataClick()">Add</button>
      <!-- </span> -->
  
    </div>
  </div>
  <p-table [value]="data" [columns]="columns" [scrollable]="true" scrollDirection="horizontal" scrollHeight="350px"
    [resizableColumns]="true" [paginator]="pagination" [lazy]="pagination" [totalRecords]='totalRecords' [first]="first"
    [rows]="rows" (onLazyLoad)='loadMoreData($event)' [loading]='loading' [rowsPerPageOptions]='rowsPerPage'
    [showCurrentPageReport]="true" currentPageReportTemplate="Showing 
    {first} to {last} of {{totalRecords}}" (onSort)="onSort($event)">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <ng-container *ngFor="let col of columns">
          <th pFrozenColumn [frozen]="col?.isFrozenColumn" [pSortableColumnDisabled]="!col.sortable"
            [pSortableColumn]="col.field" style="max-width:300px">
            {{col.header}}
            <i *ngIf="col.sortable" class="p-sortable-column-icon pi pi-fw" [ngClass]="{ 
            'pi-sort-alt': sortField !== col.field || sortOrder === null,
             'pi-sort-amount-up-alt': sortField === col.field && sortOrder === 1,
             'pi-sort-amount-down': sortField === col.field && sortOrder === -1
              }"></i>
          </th>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row let-columns="columns">
      <tr>
        <ng-container *ngFor="let col of columns">
          <td *ngIf="!col?.showEditIcon && !col?.showCopyIcon && !col?.showViewIcon" pFrozenColumn pTooltip="{{row[col.field]}}" [frozen]="col?.isFrozenColumn"
            style="max-width:300px">
            {{row[col.field]}}
          </td>
          <td *ngIf="col?.showEditIcon" (click)="editData(row)" pFrozenColumn [frozen]="col?.isFrozenColumn">
            <span class="edit-icon">
              <svg height="14px" version="1.1" viewBox="0 0 18 18" width="14px">
                <g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1">
                  <g fill="#000000" id="Core" transform="translate(-213.000000, -129.000000)">
                    <g id="create" transform="translate(213.000000, 129.000000)">
                      <path
                        d="M0,14.2 L0,18 L3.8,18 L14.8,6.9 L11,3.1 L0,14.2 L0,14.2 Z M17.7,4 C18.1,3.6 18.1,3 17.7,2.6 L15.4,0.3 C15,-0.1 14.4,-0.1 14,0.3 L12.2,2.1 L16,5.9 L17.7,4 L17.7,4 Z"
                        id="Shape" />
                    </g>
                  </g>
                </g>
              </svg>
            </span>
          </td>
          <td *ngIf="col?.showCopyIcon" (click)="copyData(row)" pFrozenColumn [frozen]="col?.isFrozenColumn">
            <span class="edit-icon">
              <i class="pi pi-copy"></i>
            </span>
          </td>
          <td *ngIf="col?.showViewIcon" (click)="viewData(row)" pFrozenColumn [frozen]="col?.isFrozenColumn">
            <span class="edit-icon">
               <i class="pi pi-eye"></i>
            </span>
          </td>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="columns.length">No records found.</td>
      </tr>
    </ng-template>
  </p-table>